import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import axios from "axios";
import {toggleLoader} from "../actions/setting";
import {useDispatch} from "react-redux";
import {loadCredential, setUsername} from "./authentication";
import FormHandler from "../util/form-handler";
import validateLogin from "./form-validation-rules";

import Logo from "../../images/SAlogo.png"

const Login = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showText, setShowText] = useState(false);
  const dispatch = useDispatch();

  const {
    values,
    errors,
    handleChange,
    handleOnBlur,
    handleSubmit,
  } = FormHandler(login, validateLogin);

  function login() {
    setIsLoading(true);
  }

  useEffect(() => {
    if (!isLoading) {
      return;
    }
    dispatch(toggleLoader(true));

    const body = 'client_id=' + "yield-client"
      + '&client_secret=' + "yield-secret"
      + '&grant_type=' + "password"
      + '&username=' + values.username
      + '&password=' + values.password;

    axios.post(process.env.REACT_APP_HOST + `/oauth/token`, body)
      .then(function (response) {
        setIsLoading(false);
        setUsername(values.username);
        loadCredential(response.data);
        dispatch(toggleLoader(false));

        const reqUrl = localStorage.getItem('REQUESTED_URL');
        if (!reqUrl || reqUrl.includes("login")) {
          props.history.push('/home');
        } else {
          props.history.push(reqUrl);
        }
        localStorage.setItem('REQUESTED_URL', '');
      })
      .catch(function (error) {
        errors.message = "UserName or Password is Wrong";
        setIsLoading(false);
        dispatch(toggleLoader(false));
      })
  }, [isLoading]);

  return (
    <div className="login-background" id="login">
      <div className="login-inner">
        <div className="login-box">
          <div className="login-logo">
            <img className="login-logo-image" src={Logo} alt="logo"/>
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group m-b-16">
              <label htmlFor="email">Username</label>
              <input type="text" value={values.username || ''} onChange={handleChange} onBlur={handleOnBlur}
                     className={errors.username ? "form-control warning-input" : "form-control"}
                     name="username" placeholder="Enter your username"/>
              {errors.username && (
                <p className="warning-input-msg">{errors.username}</p>)}
            </div>
            <div className="form-group m-b-6">
              <label htmlFor="pwd">Password</label>
              <input type={!showText ? "password" : "text"} value={values.password || ''} onChange={handleChange}
                     onBlur={handleOnBlur}
                     className={errors.password ? "form-control warning-input" : "form-control"}
                     name="password"
                     placeholder="Enter your password"/>
              <span className="field-icon" onClick={() => setShowText(!showText)}><FeatherIcon
                className="toggle-password" icon={showText ? "eye-off" : "eye"}/></span>
              {errors.password && (
                <p className="warning-input-msg">{errors.password}</p>)}
            </div>
            {errors.message && (<div className={"login-warning-msg"}>{errors.message}</div>)}
            <div className="login-text-btn m-b-9">
              Forgot password?<Link to={"/forgot-password"}> RESET</Link>
            </div>
            <button className="btn btn-sa-primary-factoryspy w-100 m-b-14">LOGIN</button>
          </form>
        </div>
      </div>
    </div>);
};


export default Login
